import { Skeleton } from '@ibsys/kit';
import { FC } from 'react';
import { cn } from '@/shared/lib';
import { SkeletonDialog } from './SkeletonDialog';

type Props = {
  className?: string;
};

/** Условное изображение карточки диалога — данные и лента реплик — в превью раскладки */
export const SkeletonMetaDialog: FC<Props> = ({ className }) => (
  <div className={cn('flex gap-1 w-full flex-1 overflow-hidden', className)}>
    <Skeleton className={'h-full w-3/4 grow-0'} />
    <SkeletonDialog className={'h-full w-14'} />
  </div>
);
